var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141,
    height: 141.198,
    viewBox: "0 0 141 141.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bg",
    x: 0,
    y: 0,
    width: 141,
    height: 141.198,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6a49f2",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Premium",
    transform: "translate(-5353.5 -6937.296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5353.5, 6937.3)",
    filter: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    d: "M1254,7055c36.11-24.766,51,12.146,51,37a45,45,0,1,1-90,0C1215,7067.142,1233.5,7069.053,1254,7055Z",
    transform: "translate(-1189.5 -7036.3)",
    fill: "#6a49f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(4164 -99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    transform: "translate(1172.837 7051.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M92.988,48.507a3.47,3.47,0,0,1-.454-1.828,4.272,4.272,0,0,1,.085-.857l-2.45,2.3A10.366,10.366,0,0,0,92.988,48.507Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M90.3,31.6H86.378a.207.207,0,0,0-.176.314l1.447,2.428,1.739-.1,3.757-.223-2.367-2.227A.689.689,0,0,0,90.3,31.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M74.695,41.441a5.42,5.42,0,0,0,2.2-2.024.448.448,0,0,0-.252-.625,6.065,6.065,0,0,0-1.9-.331,3.7,3.7,0,0,0-2.289.721.5.5,0,0,0-.088.087l-1.548,1.961a.6.6,0,0,0,.383.965,5.04,5.04,0,0,0,.7.049A5.374,5.374,0,0,0,74.695,41.441Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M95.828,41.751a.417.417,0,0,0-.15-.7,13.438,13.438,0,0,0-4.232-.66,14.927,14.927,0,0,0-4.942.852.424.424,0,0,0-.222.182l-4.066,6.821a.7.7,0,0,0,.593,1.057h4.456a1.351,1.351,0,0,0,.925-.368Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M94.154,44.888c-.474,0-.858.8-.858,1.79s.384,1.79.858,1.79.859-.8.859-1.79S94.628,44.888,94.154,44.888Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M103.553,37.42c-.037-.048-.071-.1-.107-.151C103.482,37.32,103.516,37.372,103.553,37.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M103.18,36.845c.058.106.119.207.181.3C103.3,37.051,103.238,36.951,103.18,36.845Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M107.028,39.483a17.034,17.034,0,0,1-2.162-.925h0c-.7.554-3.305.755-4.333.567a3.1,3.1,0,0,1-1.811-1.289.531.531,0,0,1,.444-.842c2.852.088,3.683-.562,3.724-.595a4.636,4.636,0,0,1,.289.445,4.7,4.7,0,0,0-4.219-2.392q-.162,0-.325.01l-9.2.547-13.1.778-2.166-3.411A2.3,2.3,0,0,0,72.227,31.3c-.045,0-.09,0-.136,0l-3.239.192a.736.736,0,0,0-.605,1.076c.754,1.451,2.187,4.191,3.382,6.387l.138-.174a1.258,1.258,0,0,1,.224-.221,4.417,4.417,0,0,1,2.748-.876,6.807,6.807,0,0,1,2.145.37,1.2,1.2,0,0,1,.725.684,1.232,1.232,0,0,1-.035,1.011A6.258,6.258,0,0,1,75.085,42.1c-.193.116-.39.218-.588.312a3.726,3.726,0,0,0,.582.193A58.259,58.259,0,0,0,84,43.773L85.63,41.03a1.188,1.188,0,0,1,.625-.512,15.706,15.706,0,0,1,5.191-.894,14.3,14.3,0,0,1,4.473.7,1.17,1.17,0,0,1,.775.871,1.182,1.182,0,0,1-.347,1.118L94.469,44.08c4.209,0,7.771-.125,9.477-.185C109.561,43.7,108.41,40.046,107.028,39.483Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M103.755,37.665c-.029-.032-.057-.068-.085-.1C103.7,37.6,103.726,37.633,103.755,37.665Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M104.181,38.081l-.048-.042Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M104.633,38.416l-.016-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M103.9,37.816c.022.022.044.047.066.068C103.942,37.863,103.92,37.838,103.9,37.816Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M104.4,38.258l-.032-.025Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.247,
    height: 1.709,
    rx: 0.32,
    transform: "translate(79.891 37.797)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1.247,
    height: 1.709,
    rx: 0.32,
    transform: "translate(83.362 37.797)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 1.247,
    height: 1.709,
    rx: 0.32,
    transform: "translate(86.833 37.797)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 1.247,
    height: 1.709,
    rx: 0.32,
    transform: "translate(90.304 37.797)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1.247,
    height: 1.709,
    rx: 0.32,
    transform: "translate(93.774 37.797)",
    fill: "#f7941d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M1255.646,7101a.7.7,0,0,1-.593-1.059l4.067-6.82a.415.415,0,0,1,.223-.182,14.921,14.921,0,0,1,4.942-.852,13.441,13.441,0,0,1,4.231.659.416.416,0,0,1,.151.7l-7.64,7.189a1.353,1.353,0,0,1-.925.367Zm7.36-1.18,2.449-2.3a4.343,4.343,0,0,0-.084.857,3.469,3.469,0,0,0,.454,1.828A10.265,10.265,0,0,1,1263.006,7099.821Zm3.126-1.447c0-.987.385-1.791.859-1.791s.859.8.859,1.791-.385,1.791-.859,1.791S1266.131,7099.363,1266.131,7098.374Zm3.053-4.366a1.188,1.188,0,0,0-.428-1.989,14.287,14.287,0,0,0-4.473-.7,15.7,15.7,0,0,0-5.191.893,1.2,1.2,0,0,0-.625.513l-1.634,2.743a58.345,58.345,0,0,1-8.918-1.169,3.685,3.685,0,0,1-.581-.192,6.338,6.338,0,0,0,.586-.312,6.246,6.246,0,0,0,2.491-2.343,1.228,1.228,0,0,0,.036-1.011,1.2,1.2,0,0,0-.725-.682,6.736,6.736,0,0,0-2.146-.371,4.419,4.419,0,0,0-2.748.875,1.394,1.394,0,0,0-.225.221l-.137.175c-1.194-2.2-2.627-4.935-3.382-6.387a.737.737,0,0,1,.606-1.077l3.238-.19c.046,0,.091-.005.135-.005a2.3,2.3,0,0,1,1.943,1.073l2.165,3.411,13.1-.779,9.2-.547c.109-.005.216-.009.324-.009a4.7,4.7,0,0,1,4.22,2.392,4.249,4.249,0,0,0-.291-.445c-.039.034-.871.683-3.723.6a.53.53,0,0,0-.444.841,3.092,3.092,0,0,0,1.811,1.291c1.028.187,3.635-.014,4.332-.567a16.95,16.95,0,0,0,2.162.923c1.383.565,2.534,4.218-3.081,4.413-1.707.061-5.268.184-9.477.185Zm-25.149-.118a.6.6,0,0,1-.383-.966l1.547-1.96a.579.579,0,0,1,.089-.087,3.7,3.7,0,0,1,2.288-.72,6.075,6.075,0,0,1,1.9.33.449.449,0,0,1,.253.625,6.4,6.4,0,0,1-5,2.826A5.162,5.162,0,0,1,1244.035,7093.89Zm33.42-3.789.014.009Zm-.246-.173.032.025Zm-.239-.194c.014.013.032.029.048.041C1277,7089.763,1276.985,7089.747,1276.97,7089.734Zm-.235-.223c.021.023.043.046.066.07C1276.778,7089.558,1276.756,7089.535,1276.735,7089.511Zm-.23-.253c.028.034.057.069.085.1C1276.562,7089.328,1276.534,7089.292,1276.505,7089.258Zm-.223-.294c.036.052.069.1.107.151C1276.352,7089.067,1276.318,7089.016,1276.282,7088.964Zm-.266-.424c.057.107.118.207.182.3C1276.135,7088.747,1276.074,7088.647,1276.017,7088.54Zm-16.978-4.928a.2.2,0,0,1,.175-.312h3.928a.685.685,0,0,1,.472.187l2.368,2.226-3.757.224-1.739.1Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.122e5213e7e29c8486054ec6f41e165f.svg";
export { ForwardRef as ReactComponent };